import React from 'react';
import { PRIMARY_COLOR } from '@constants/colors';

export default ({ color = '#928E8D', size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.77361 3.90297C6.1215 3.19493 4.80507 1.8785 4.09703 0.226395L4 0L3.90297 0.226395C3.19493 1.8785 1.8785 3.19493 0.226395 3.90297L0 4L0.226395 4.09703C1.8785 4.80507 3.19493 6.1215 3.90297 7.77361L4 8L4.09703 7.77361C4.80507 6.1215 6.1215 4.80507 7.77361 4.09703L8 4L7.77361 3.90297Z"
      fill={color}
    />
    <path
      d="M12 8C11.1013 7.61483 10.3852 6.89872 10 6C9.61484 6.89872 8.89872 7.61483 8 8C8.89872 8.38517 9.61484 9.10128 10 10C10.3852 9.10128 11.1013 8.38517 12 8Z"
      fill={color}
    />
  </svg>
);
